<article>
	<h1 mat-dialog-title class="h1 h1--component-title">
		<ng-container *ngIf="data.title == null">
			{{"dialog.title.info" | translate | async}}
		</ng-container>

		<ng-container *ngIf="data.title != null">
			{{ data.title | translate | async }}
		</ng-container>
	</h1>

	<div mat-dialog-content>
		<p innerHTML="{{ data.message | translate | async }} {{ data.msgSuffix }} {{ data.customMessage$ | async}}">
			{{data.message | translate | async }} {{ data.msgSuffix }} {{ data.customMessage$ | async}}
		</p>
	</div>

	<div mat-dialog-actions class="flex flex--end-vertical">
		<div class="flex-child flex-child--flex-shrink ">
			<button type="button" *ngIf="data.displayBtnOk" class="button {{data.btnOkStyle}}" mat-stroked-button [mat-dialog-close]="true" cdkFocusInitial>
				{{data.btnOk | translate | async}}
			</button>
		</div>

		<div class="flex-child flex-child--flex-shrink ">
			<button type="button" class="button" [ngClass]="(data.displayBtnOk) ? 'button--black-secondary' : 'button--black-primary'" mat-stroked-button (click)="onNoClick()">
				{{ data.btnCancel | translate | async }}
			</button>
		</div> 
	</div>
</article>